import { Component, OnInit, Injector } from '@angular/core';
import { TenantDashboardServiceProxy } from '@shared/service-proxies/service-proxies';
import { DashboardChartBase } from '../dashboard-chart-base';
import { WidgetComponentBase } from '../widget-component-base';
import * as moment from 'moment';

class DashboardFinancialNewOrders extends DashboardChartBase {

  newOrders = 0; newOrdersCounter = 0;
  newOrdersChange = 0; newOrdersChangeCounter = 0;

  init(newOrders, newOrdersChange) {
    this.newOrders = newOrders;
    this.newOrdersChange = newOrdersChange,
    this.hideLoading();
  }
}

@Component({
  selector: 'app-widget-financial-new-orders',
  templateUrl: './widget-financial-new-orders.component.html',
  styleUrls: ['./widget-financial-new-orders.component.css']
})
export class WidgetFinancialNewOrdersComponent extends WidgetComponentBase implements OnInit {

  dashboardTopStats: DashboardFinancialNewOrders;
  selectedDateRange: moment.Moment[] = [moment().startOf('year'), moment().endOf('day')];
  
  constructor(injector: Injector,
    private _tenantDashboardServiceProxy: TenantDashboardServiceProxy
  ) {
    super(injector);
    this.dashboardTopStats = new DashboardFinancialNewOrders();
  }

  ngOnInit() {
    this.subDateRangeFilter();
    this.runDelayed(this.loadTopStatsData);
  }

  loadTopStatsData = () => {
    this._tenantDashboardServiceProxy.getFinancialNewOrders(this.selectedDateRange[0], this.selectedDateRange[1], undefined).subscribe((data) => {
      this.dashboardTopStats.init(data.total, data.totalChange);
    });
  }

  onDateRangeFilterChange = (dateRange) => {
    if (!dateRange || dateRange.length !== 2 || (this.selectedDateRange[0] === dateRange[0] && this.selectedDateRange[1] === dateRange[1])) {
      return;
    }

    this.selectedDateRange[0] = dateRange[0];
    this.selectedDateRange[1] = dateRange[1];
    this.runDelayed(this.loadTopStatsData);
  }

  subDateRangeFilter() {
    abp.event.on('app.dashboardFilters.dateRangePicker.onDateChange', this.onDateRangeFilterChange);
  }

  unSubDateRangeFilter() {
    abp.event.off('app.dashboardFilters.dateRangePicker.onDateChange', this.onDateRangeFilterChange);
  }

  ngOnDestroy(): void {
    this.unSubDateRangeFilter();
  }
}
